import React from "react";
import { Box, Typography } from "@mui/material";
import { ResourceCentre } from "./LabPrintLetterhead";
import { scaleFont } from "../LabPrintFunctions";

interface LabPrintLetterHeadProps {
  resourceCentre: Partial<ResourceCentre>;
  titleFontScale?: number;
  hideRcLogo?: boolean;
}

const LabPrintLetterHeadCentered: React.FC<LabPrintLetterHeadProps> = ({
  resourceCentre: {
    resourceCentreLogo,
    name,
    slogan,
    address,
    city,
    registrationNumber,
    phone,
    phone2,
    mobileNumber,
    optionalPhone,
    web,
    email,
    panNo
  },
  titleFontScale = 1,
  hideRcLogo = false
}) => (
  <Box width="100%" display="flex" justifyContent="space-between">
    <Box style={{ width: "3.2cm", height: "auto" }}>
      {!hideRcLogo && resourceCentreLogo && (
        <Box>
          <img
            src={resourceCentreLogo.s3ResourceURL}
            alt="logo"
            style={{ width: "2.6cm", height: "auto" }}
          />
        </Box>
      )}
    </Box>
    <Box flex={1} alignItems="center">
      <Typography
        style={{
          fontWeight: 500,
          fontSize: scaleFont("0.68cm", titleFontScale),
          textAlign: "center"
        }}
      >
        {name}
      </Typography>
      {slogan && (
        <Typography style={{ fontSize: "0.35cm", fontWeight: 400, textAlign: "center" }}>
          {slogan}
        </Typography>
      )}
      <Typography style={{ textAlign: "center", textTransform: "capitalize", fontSize: "0.325cm" }}>
        {address} {city}
      </Typography>
      <Typography style={{ textAlign: "center", fontSize: "0.325cm" }}>
        {mobileNumber ? `${mobileNumber}, ` : ""}
        {phone}
        {optionalPhone && `, ${optionalPhone}`} {phone2 && `, ${phone2}`} {email && `, ${email}`}{" "}
        {web && `, ${web}`}
      </Typography>
    </Box>
    <Box style={{ width: "3.2cm", height: "auto" }}>
      {registrationNumber && (
        <Typography
          style={{ textAlign: "right", textTransform: "capitalize", fontSize: "0.300cm" }}
        >
          Reg No: {registrationNumber}
        </Typography>
      )}
      {Boolean(panNo) && (
        <Typography style={{ textAlign: "right", fontSize: "0.300cm" }}>Pan No: {panNo}</Typography>
      )}
    </Box>
  </Box>
);

export default LabPrintLetterHeadCentered;
